import { DepositResult } from '../../../api/web3/deposit-api'
import { oracleApi } from '../../../api/oracle/oracle-client'
import { createEarnTabEvent, createFailureEvent } from 'user-events-segment'
import { Amounts } from '../../../logic/token/amounts'
import { Token } from '../../../logic/token/token'
import { fromWei } from '../../../utils/static-web3'
import { Pool } from '../../../logic/pools/Pool'

// TODO: probably export this everywhere
type DepositTabOption = '1-asset' | 'all-asset'
type DepositMode =
  | '1_asset_with_swaap'
  | 'all_asset'
  | '1_asset_with_aggregator'

export interface DepositReducerState {
  depositTab: DepositTabOption
  mode: DepositMode
  pool: Pool
}

export interface DepositAction {
  type:
    | 'choose-pool'
    | 'failure'
    | 'success'
    | 'change-tab'
    | 'show-preview'
    | 'execute-deposit'
  pool?: Pool
  result?: DepositResult
  // TODO: rename bringIn into bring_in and have a real type
  data?: Partial<DepositResult> & any
  tab?: DepositTabOption
  mode?: DepositMode
}

export function depositReducer(
  state: DepositReducerState,
  action: DepositAction
): DepositReducerState {
  let newState = { ...state }
  switch (action.type) {
    case 'choose-pool':
      return {
        ...state,
        pool: action.pool!,
      }
    case 'change-tab':
      return {
        ...state,
        depositTab: action.tab!,
        mode:
          action.tab === '1-asset' ? '1_asset_with_aggregator' : 'all_asset',
      }

    case 'show-preview':
      fire_clicked_preview_deposit(action.data, state)
      return state
    case 'execute-deposit':
      newState.mode = action.mode!
      fire_clicked_confirmed_deposit(action.data, newState)
      return newState
    case 'failure':
      fire_deposit_failure_event(action.data, state)
      //TODO: should replace/merge the current funnelState
      return state
  }
  return state
}

function fire_clicked_preview_deposit(
  data: Partial<DepositResult> & any,
  state: DepositReducerState
) {
  const pool = state.pool
  createEarnTabEvent(pool).clicked_preview_deposit(
    state.depositTab,
    data.bringIn.toAnalyticObject()
  )
}

function fire_clicked_confirmed_deposit(
  data: Partial<DepositResult> & any,
  state: DepositReducerState
) {
  // TODO naming: rename bringIn and amounts more conform to analytics naming
  const { bringIn, amounts, expected_minted_shares, minimal_minted_shares } =
    data
  const pool = state.pool
  createEarnTabEvent(pool).clicked_confirmed_deposit(
    state.depositTab,
    state.mode,
    bringIn.toAnalyticObject(),
    Amounts.fromMap(amounts).toAnalyticObject(),
    fromWei(expected_minted_shares, 18),
    fromWei(minimal_minted_shares, 18)
  )
}

function fire_deposit_failure_event(
  data: Partial<DepositResult> & any,
  state: DepositReducerState
) {
  const { step, reason, amounts } = data
  const pool = state.pool
  const poolAddress = pool.address
  const tokens = pool.tokens.map((t: Token) => t.symbol)

  oracleApi.getPrices().then(() => {
    createFailureEvent().deposit_failure(
      step,
      reason,
      poolAddress,
      tokens,
      state.depositTab,
      state.mode,
      data.bringIn.toAnalyticObject(),
      Amounts.fromMap(amounts).toAnalyticObject(),
      fromWei(data.expected_minted, 18),
      oracleApi.calculateBag(Amounts.fromMap(amounts)),
      data.hash
    )
  })
}
